import { Box, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

interface ContextMenuProps {
  contextMenu: {
    mouseX: number;
    mouseY: number;
    coordinates: [number, number];
  } | null;
  onClose: () => void;
  onCopy: () => void;
}

export const ContextMenu: React.FC<ContextMenuProps> = ({ contextMenu, onClose, onCopy }) => {
  if (!contextMenu) return null;

  return (
    <Menu
      open={true}
      onClose={onClose}
      anchorReference='anchorPosition'
      anchorPosition={{ top: contextMenu.mouseY, left: contextMenu.mouseX }}
      slotProps={{
        paper: { sx: { minWidth: 200 } }
      }}
      aria-label='Map context menu'
    >
      <MenuItem onClick={onCopy}>
        <ListItemIcon>
          <ContentCopyIcon fontSize='small' />
        </ListItemIcon>
        <ListItemText
          primary='Copy Coordinates'
          secondary={
            <Box component='span' sx={{ display: "block", fontSize: "0.75rem", color: "text.secondary" }}>
              {contextMenu.coordinates[1].toFixed(6)}, {contextMenu.coordinates[0].toFixed(6)}
            </Box>
          }
        />
      </MenuItem>
    </Menu>
  );
};
